import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import DI from "../utility/DI";
import { CircularProgress } from "@mui/material";
import Footer from "../utility/Footer";
import { useNavigate, useParams } from "react-router-dom";
import { PasswordInput } from "../utility/PasswordInput";
function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://mui.com/">
        Your Website
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

// TODO remove, this demo shouldn't need to reset the theme.

const defaultTheme = createTheme();

const ResetPassword = (props) => {
  const [loginSuccess, setLoginSuccess] = React.useState(false);
  const {
    di: {
      success,
      error,
      POST,
      GET,
      urls,
      logout,
      contextData: { setState },
    },
  } = props;
  const navigate = useNavigate();

  let { id, otp } = useParams();
  const [loading, setLoading] = React.useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    const data = new FormData(event.currentTarget);
    const new_password = data.get("confirm_password");
    const password = data.get("password");
    if (new_password && password && new_password !== password) {
      error("New Password & Confirm Password must be same.");
      return;
    }
    if (new_password && password) {
      setLoading(true);
      POST(urls.post.change_password, { id, otp, password })
        .then((res) => {
          if (res.success) {
            setState((prev) => {
              return { ...prev, session: {} };
            });

            setLoading(false);
            setLoginSuccess(true);
            success(res?.message);
            form.reset();
            logout();
            navigate("/login");
          } else {
            setLoading(false);
            error(res?.message);
          }
        })
        .catch((er) => {
          setLoading(false);
          error("Refresh page & Try again.");
          console.log({ Error: er });
        });
    } else error("Fields cant be empty.");
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div style={{ width: "80px" }}>
          <img
            style={{ width: "100%" }}
            src={"/transparent_logo.png"}
            alt={"spent_app"}
            loading="lazy"
          />
        </div>
        <Typography component="h2" sx={{ mt: 2 }} variant="h5">
          Change Password
        </Typography>
        <Box
          component="form"
          onSubmit={handleSubmit}
          noValidate
          sx={{ mt: 1, px: 2 }}
        >
          <PasswordInput
            margin="normal"
            required
            fullWidth
            placeholder={"Pass@123"}
            name="password"
            label="New Password"
            id="password"
            autoComplete="new-password"
          />
          <PasswordInput
            margin="normal"
            required
            fullWidth
            placeholder={"Pass@123"}
            name="confirm_password"
            label="Confirm Password"
            id="confirm-password"
            autoComplete="confirm-password"
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            loading={true}
            sx={{ mt: 3, mb: 2 }}
          >
            {loading ? (
              <CircularProgress color="inherit" size={20} />
            ) : (
              "Change Password"
            )}
          </Button>
        </Box>
      </Box>
      <div style={{ marginTop: "20px" }}>
        <Footer />
      </div>
    </Container>
  );
};
export default DI(ResetPassword);
